import React, { useEffect, useState } from 'react';
import {
  Section,
  SettingToggle,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
} from '@views/Settings/components';

const STRIPE_TEST_MODE_KEY = 'clay_use_stripe_test_mode';

export const getStripeTestModeEnabled = () => {
  return window.localStorage.getItem(STRIPE_TEST_MODE_KEY) === 'true';
};

const setStripeTestModeEnabled = (enabled: boolean) => {
  window.localStorage.setItem(STRIPE_TEST_MODE_KEY, enabled ? 'true' : 'false');
};

export default function StripeTesting() {
  const [stripeTestModeEnabled, _setStripeTestModeEnabled] = useState(getStripeTestModeEnabled());

  useEffect(() => {
    setStripeTestModeEnabled(stripeTestModeEnabled);
  }, [stripeTestModeEnabled]);

  return (
    <Section>
      <SettingsSectionLabel>Stripe Test Mode</SettingsSectionLabel>
      <SettingsSectionBox>
        <SettingsSectionRow
          style={{
            gap: 8,
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            paddingTop: 10,
            paddingBottom: 12,
          }}
        >
          <SettingToggle
            title="Use Stripe Test Mode in Staging"
            checked={stripeTestModeEnabled}
            name="activity_news"
            onChange={() => _setStripeTestModeEnabled(!stripeTestModeEnabled)}
          />
          <p>
            See{' '}
            <a href="https://stripe.com/docs/test-mode" target="_blank">
              Stripe's testing documentation
            </a>{' '}
            for more information. After making a change, you'll need to restart the app for the
            change to take effect.
          </p>
        </SettingsSectionRow>
      </SettingsSectionBox>
    </Section>
  );
}
